import { useAddressHistory } from "modules/AddressHistory/api";
import { useWorkOrderByCustomerId } from "./use-work-order-by-customer-id";
import { useCustomerProducts } from "modules/CustomerProducts/api";
export const useCustomerInfoPage = (customerId) => {
    var _a;
    const { workOrderByCustomerId, isLoading: isWorkOrderByCustomerIdLoading, workOrderByCustomerIdErrorMessage, } = useWorkOrderByCustomerId(customerId);
    const validAddressId = (_a = workOrderByCustomerId === null || workOrderByCustomerId === void 0 ? void 0 : workOrderByCustomerId.address) === null || _a === void 0 ? void 0 : _a.validAddressId;
    const addressHistoryQuery = useAddressHistory(true, undefined, validAddressId);
    const customerProductsQuery = useCustomerProducts(customerId);
    return {
        workOrderByCustomerId,
        addressHistory: addressHistoryQuery.addressHistory,
        customerProducts: customerProductsQuery.customerProducts,
        isLoading: isWorkOrderByCustomerIdLoading ||
            addressHistoryQuery.isAddressHistoryLoading ||
            customerProductsQuery.isCustomerProductsLoading,
        workOrderByCustomerIdErrorMessage,
        addressHistoryError: addressHistoryQuery.addressHistoryError,
        customerProductsError: customerProductsQuery.customerProductsErrorMessage,
    };
};
